module.exports = __webpack_public_path__ + "fonts/Satoshi-Italic.e5944df.woff2";